export default __webpack_public_path__ + "927a50196af388fef198c6c37d8bb2ab.svg";